import {TableDefinition} from '../../models';

export const GROUP_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Group.id',
    prop: 'id',
    visible: false,
    objectName: 'Group',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Group.name',
    prop: 'name',
    visible: true,
    objectName: 'Group',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Group.contactListTotal',
    prop: 'contactListTotal',
    visible: true,
    sortDisabled: true,
  },
  {
    key: 'API.fields.Group.representativeListTotal',
    prop: 'representativeListTotal',
    visible: true,
    sortDisabled: true,
  },
];
